import { Container, Header, Text, Visibility } from '@gasbuddy/react-components';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import GetTheAppButton from '../GetTheAppButton';
import styles from './Hero.module.css';

const cx = classnames.bind(styles);

const Hero = ({ onButtonClick }) => (
  <div style={{ position: 'relative' }}>
    <div className={cx('heroBanner')} />
    <Container className={cx('heroContainer')}>
      <Visibility desktop={false} tablet={false}>
        <Header as="h1" className={cx('heroTitle')}>
          Free gas
          <br />
          from everyday
          <br />
          purchases.
        </Header>
      </Visibility>
      <Visibility mobile={false}>
        <Header as="h1" className={cx('heroTitle')}>
          Free gas from
          <br />
          everyday purchases.
        </Header>
      </Visibility>
      <Text as="p" className={cx('heroText')}>
        Live your life and earn free gas.
        <br />
        Available on our top-rated app.
      </Text>
      <GetTheAppButton className={cx('heroButton')} onClick={onButtonClick} />
    </Container>
  </div>
);

Hero.propTypes = {
  onButtonClick: PropTypes.func,
};

Hero.defaultProps = {
  onButtonClick: undefined,
};

export default Hero;
